var _defs, _g, _path, _path2, _path3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225,
    height: 94.822,
    viewBox: "0 0 225 94.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2454",
    "data-name": "Rectangle 2454",
    width: 204.712,
    height: 69.716,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2453",
    "data-name": "Rectangle 2453",
    width: 123.812,
    height: 42.002,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(-75 -5257.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001",
    transform: "translate(-83 5222.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233",
    transform: "translate(168.141 35.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3238",
    "data-name": "Group 3238",
    transform: "translate(80.9 27.714)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3237",
    "data-name": "Group 3237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3236",
    "data-name": "Group 3236",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3233-2",
    "data-name": "Group 3233",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ascent",
    transform: "translate(0 31.142)",
    fill: "#acacac",
    fontSize: 37,
    fontFamily: "Montserrat-Light, Montserrat",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "as"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.008em"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ent"))))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M23.134,10.418,51.278,59.7h12.1L29.12.1Z",
    transform: "translate(5.392 0.025)",
    fill: "#b92a2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M34.512,0,0,59.727H11.972l28.4-49.285Z",
    transform: "translate(0 0.001)",
    fill: "#ea5946"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M27.885,18.655,33.87,8.469V8.6L30.559,23.114Z",
    transform: "translate(6.5 1.975)",
    fill: "#8e1f22"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Predictive_Growth_Solutions",
    "data-name": "Predictive Growth Solutions",
    transform: "translate(158 105)",
    fill: "#666",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.25,
    y: 17
  }, "Predictive Growth Solutions"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignedLogo);
export default __webpack_public_path__ + "static/media/alignedLogo.d1de43805b140908557170e89066e76f.svg";
export { ForwardRef as ReactComponent };